import type { FaireProductEntity } from "../../entity_types/product";

export const p_6kn42tvm7r: FaireProductEntity = {
  token: "p_6kn42tvm7r",
  type: "product",
  name: "Butter Squish Stress Relief Toy – 2 Sizes",
  brandToken: "b_q74ps4ybre",
  brandName: "NOVA BRANDS",
  imageUrl:
    "https://cdn.faire.com/fastly/0aae3bb1a7740d4c937cdb62689be0232e355930519c3965e4ba17295592a0bd.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/33eb18174728f0f1ecddd5313d560da27bf9e9899d796ea7393dc4e8276aa151.jpeg",
    "https://cdn.faire.com/fastly/593e67f2e81c3867b142646a1ef37bf3a9077f61e94b03f7c17da114c0da9a65.jpeg",
    "https://cdn.faire.com/fastly/f7e04862b574e5dc8b06d8f082bf5ca33ffb9c79a6b84eaa29e5fae547aa40d8.jpeg",
    "https://cdn.faire.com/fastly/af4134bf35a4e78b08fdde4eb69706f22779b2a41cb7799ea7f98eef4ae682ed.jpeg",
  ],
  priceDollars: 3.5,
  description:
    "Add a playful twist to your toy selection with our Butter Squish Stress Relief Toys! These ultra-soft sensory squishies are designed for satisfying squeezes, stress relief, fidget play, and sensory fun for both kids and adults.\n\nAvailable in two sizes:\n• Small – 5”\n• Jumbo – 9”\n\nMade with a super soft, slow-squish texture that customers love for:\n• Stress relief\n• Sensory play\n• Desk fidget fun\n• Gift shops & impulse displays\n• TikTok trending toy sections\n\nPerfect for:\nToy stores, gift shops, mall kiosks, candy shops, sensory sections, novelty retailers, and checkout displays.\n\nProduct Features:\n• Soft squishy texture\n• Fun butter-stick inspired design\n• Great impulse purchase item\n• Individually packaged\n• Ages 3+\n\nStyles may slightly vary by batch.\n\nsquishy toy, sensory toy, stress relief toy, fidget toy, kawaii toy, jumbo squishy, squeeze toy, novelty toy, desk toy, sensory play, slow rise squishy, trending toy, impulse buy, gift shop toy, tiktok toy, anxiety relief toy, soft squishy, sensory fidget, stress squeeze toy, squishmallow style toy ",
  tags: [],
  msrpDollars: 7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:58:41.307Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
